<template>
  <div v-if="displayTriggerFile" class="trigger-file__checkbox">
    <div>
      <input type="checkbox" id="checkbox" v-model="checked" />
      <label for="checkbox">
        {{ translate('frequency.modal.triggerFile.check') }}
      </label>
    </div>
    <div
      class="info-label"
      id="infoTrigger"
      @mouseover="toggle = true"
      @mouseleave="toggle = false"
      @focus="toggle = true"
      @blur="toggle = false"
    >
      <mds-inline-message size="small" variation="informational" />
    </div>
    <mds-tooltip
      v-model="toggle"
      size="small"
      triggered-by="infoTrigger"
      :position="['top-right']"
    >
      {{ translate('frequency.modal.triggerFile.tooltip') }}
    </mds-tooltip>
  </div>
</template>

<script>
import MdsInlineMessage from '@mds/inline-message'
import MdsTooltip from '@mds/tooltip'
import MwcBaseHelpersMixin from '@morningstar/mcl-utilities/src/vue/mixins/mwc-base-mixin'
import defaultConfig from '../../config/i18n'

export default {
  name: 'TriggerFile',
  components: {
    MdsInlineMessage,
    MdsTooltip,
  },
  props: {
    displayTriggerFile: Boolean,
  },
  mixins: [MwcBaseHelpersMixin],
  data() {
    return {
      defaultConfig,
      checked: false,
      toggle: false,
    }
  },
  mounted() {
    this.$emit('triggerFile', { subscribeFtpTriggerFile: this.checked })
  },
  watch: {
    checked() {
      this.$emit('triggerFile', { subscribeFtpTriggerFile: this.checked })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@mds/constants';
@import '@mds/typography';

.trigger-file__checkbox {
  display: flex;
  gap: $mds-space-1-x;
}
.info-label {
  padding-top: $mds-space-quarter-x;
}
</style>
